import React from 'react';
import { MessageSquare } from 'lucide-react';
import type { TraceItem } from '@/types/trace';

interface FeedbackTabProps {
  item: TraceItem;
}

export function FeedbackTab({ item }: FeedbackTabProps) {
  // TODO: Implement feedback functionality
  const hasFeedback = false;

  if (!hasFeedback) {
    return (
      <div className="flex flex-col items-center justify-center py-8 text-center">
        <MessageSquare className="h-8 w-8 text-muted-foreground mb-3" />
        <p className="text-sm text-muted-foreground">
          There is no feedback recorded for this run
        </p>
        <p className="text-xs text-muted-foreground mt-1">
          Feedback can be added via the API or SDK
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {/* Feedback items would go here */}
    </div>
  );
}

export default FeedbackTab;
